import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import PurchaseListTable from "views/pages/membership/purchaselist/PurchaseListTable";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

/**
 * Membership Purchase List Page
 */
const MembershipPurchaseList = () => {
  const [purchaseList, setPurchaseList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);

  // Filters
  const [status, setStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [searchText, setSearchText] = useState("");

  const [permission, setPermission] = useState({});
  const [role, setRole] = useState("");

  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();

  useEffect(() => {
    if (userData?.data?.user?.role === "2") {
      const membership = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });
      setPermission(membership[1] || {});
    } else {
      setPermission({});
    }
    setRole(userData?.data?.user?.role || "");
  }, [location.pathname, userData]);

  useEffect(() => {
    fetchPurchaseList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, pageNumber, status, paymentType, searchText]);

  const fetchPurchaseList = () => {
    Loader.isLoading(true);
    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
    };

    if (searchText) {
      payload.searchText = searchText;
    }
    if (status) {
      payload.status = status;
    }
    if (paymentType) {
      payload.paymentType = paymentType;
    }

    APICall("post", payload, EndPoints.getPurchaseMembershipList)
      .then((response) => {
        if (response.status === 200 && response.data?.data) {
          const { response: rows, totalCount } = response.data.data;
          setPurchaseList(rows || []);
          setTotalRecord(totalCount || 0);
        } else {
          setPurchaseList([]);
          setTotalRecord(0);
        }
      })
      .catch(() => toast.error("Failed to load membership purchase list"))
      .finally(() => Loader.isLoading(false));
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Membership Purchase List
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <PurchaseListTable
            purchaseList={purchaseList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            totalRecord={totalRecord}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            searchText={searchText}
            setSearchText={setSearchText}
            status={status}
            setStatus={setStatus}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default MembershipPurchaseList;
